import React from 'react'
import PropTypes from 'prop-types'

import TableSplitIconButton from '~/components/TableSplitButton/TableSplitIconButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ printBarcode, onLocationsDelete }) {
  const { handleClick } = useDeleteConfirm()
  const options = [
    {
      label: 'Print barcodes',
      'data-cy': 'printBarcodesMenu',
      onMenuClick: printBarcode
    },
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onLocationsDelete)
    }
  ]

  return (
    <TableSplitIconButton
      options={options}
      name="location"
    />
  )
}

BulkActionButton.propTypes = {
  printBarcode: PropTypes.func.isRequired,
  onLocationsDelete: PropTypes.func.isRequired
}

export default BulkActionButton
